import React from 'react';
import { motion } from 'framer-motion';
export function VisualExperience() {
  return <section className="py-24 md:py-32 relative bg-black-100/30 border-y border-gold/10 overflow-hidden" data-id="element-362">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-363">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16 md:mb-24" data-id="element-364">
          <h2 className="font-display text-4xl md:text-5xl text-cream mb-6" data-id="element-365">
            Una experiencia visual de élite
          </h2>
          <p className="text-cream/60 max-w-2xl mx-auto text-lg font-light" data-id="element-366">
            Diseñado meticulosamente en Notion para que tu experiencia de
            lectura y uso sea tan premium como el contenido.
          </p>
        </motion.div>

        <div className="relative mx-auto max-w-5xl" data-id="element-367">
          {/* Main Dashboard Mockup */}
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="rounded-xl border border-gold/20 bg-[#191919] shadow-2xl overflow-hidden relative z-10" data-id="element-368">
            {/* Window Controls */}
            <div className="h-10 bg-[#222] border-b border-white/5 flex items-center px-4 gap-2" data-id="element-369">
              <div className="w-3 h-3 rounded-full bg-white/10" data-id="element-370"></div>
              <div className="w-3 h-3 rounded-full bg-white/10" data-id="element-371"></div>
              <div className="w-3 h-3 rounded-full bg-white/10" data-id="element-372"></div>
              <div className="ml-4 text-[10px] text-white/30 font-mono" data-id="element-373">
                la-biblia-dashboard.notion.site
              </div>
            </div>

            {/* Content Area */}
            <div className="p-8 md:p-12 flex flex-col md:flex-row gap-8" data-id="element-374">
              {/* Sidebar fake */}
              <div className="hidden md:flex flex-col gap-4 w-48 border-r border-white/5 pr-6" data-id="element-375">
                <div className="h-4 w-24 bg-white/10 rounded mb-4" data-id="element-376"></div>
                <div className="h-3 w-full bg-gold/20 rounded" data-id="element-377"></div>
                <div className="h-3 w-3/4 bg-white/5 rounded" data-id="element-378"></div>
                <div className="h-3 w-5/6 bg-white/5 rounded" data-id="element-379"></div>
                <div className="h-3 w-4/5 bg-white/5 rounded" data-id="element-380"></div>
              </div>

              {/* Main fake content */}
              <div className="flex-1 space-y-6" data-id="element-381">
                <div className="flex items-center gap-4 mb-8" data-id="element-382">
                  <div className="w-16 h-16 rounded bg-gradient-to-br from-gold to-gold-dark flex items-center justify-center text-black font-display text-2xl" data-id="element-383">
                    B
                  </div>
                  <div data-id="element-384">
                    <h3 className="text-2xl font-display text-white/90" data-id="element-385">
                      La Biblia de 500 Prompts
                    </h3>
                    <p className="text-white/40 text-sm" data-id="element-386">Dashboard Principal</p>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4" data-id="element-387">
                  <div className="bg-white/5 border border-white/5 p-4 rounded-lg" data-id="element-388">
                    <div className="text-gold text-xs mb-2 uppercase tracking-widest" data-id="element-389">
                      Categoría 01
                    </div>
                    <div className="text-white/80 text-sm" data-id="element-390">
                      Ventas & Conversión
                    </div>
                  </div>
                  <div className="bg-white/5 border border-white/5 p-4 rounded-lg" data-id="element-391">
                    <div className="text-gold text-xs mb-2 uppercase tracking-widest" data-id="element-392">
                      Categoría 02
                    </div>
                    <div className="text-white/80 text-sm" data-id="element-393">
                      Creación de Contenido
                    </div>
                  </div>
                </div>

                <div className="bg-[#222] border border-white/10 p-6 rounded-lg mt-8" data-id="element-394">
                  <div className="flex items-center gap-2 mb-4" data-id="element-395">
                    <div className="w-2 h-2 bg-gold rounded-full" data-id="element-396"></div>
                    <span className="text-white/60 text-xs uppercase tracking-widest" data-id="element-397">
                      Prompt Destacado
                    </span>
                  </div>
                  <p className="text-white/80 font-mono text-sm leading-relaxed" data-id="element-398">
                    "Actúa como un experto en marketing digital. Analiza este
                    texto: [TEXTO] y reescríbelo para que genere más
                    curiosidad..."
                  </p>
                  <div className="mt-4 flex justify-end" data-id="element-399">
                    <div className="bg-white/10 px-3 py-1 rounded text-xs text-white/60 flex items-center gap-2" data-id="element-400">
                      Copiar Prompt
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Decorative floating elements */}
          <motion.div initial={{
          opacity: 0,
          x: 40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="absolute -right-8 -bottom-12 w-64 bg-black-100/90 backdrop-blur-xl border border-gold/30 p-5 rounded-lg shadow-2xl z-20 hidden md:block" data-id="element-401">
            <div className="flex items-center gap-3 mb-3" data-id="element-402">
              <div className="w-8 h-8 rounded-full bg-gold/20 flex items-center justify-center text-gold text-xs" data-id="element-403">
                IA
              </div>
              <div className="text-xs text-cream/80" data-id="element-404">Respuesta generada</div>
            </div>
            <p className="text-cream/60 text-xs leading-relaxed" data-id="element-405">
              "¡Por supuesto! Aquí tienes 3 opciones de ganchos altamente
              persuasivos para tu próximo Reel..."
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}